import { array, boolean, mixed, number, object, string } from 'yup';

import { CasinoBonusMarksEnum } from 'v2/constants';
import { CasinoModel, PromoPackTypeEnum } from 'v2/types/CasinoModel';

export type CasinoForm = Omit<CasinoModel, 'id' | 'order'>;

export const initialValues: CasinoForm = {
  name: '',
  solidLogoId: '',
  transparentLogoId: '',
  shortPromoText: '',
  fullPromoText: '',
  promoCode: '',
  marks: [],
  benefits: {
    promoPackType: PromoPackTypeEnum.STANDARD,
    freeSpinsCount: null,
    depositPercentage: null,
    customPromo: null,
  },
  ymId: '',
  link: '',
  isActive: true,
  logoVerticalId: null,
  logoSquareId: null,
  winNotificationText: '',
};

export const validationSchema = object().shape({
  name: string().required(),
  solidLogoId: string().required(),
  transparentLogoId: string().required(),
  shortPromoText: string().required(),
  fullPromoText: string().required(),
  promoCode: string().required(),
  marks: array()
    .of(mixed().oneOf(Object.values(CasinoBonusMarksEnum)))
    .required(),
  benefits: object()
    .shape({
      promoPackType: mixed<PromoPackTypeEnum>().oneOf(Object.values(PromoPackTypeEnum)).required(),
      freeSpinsCount: number()
        .nullable()
        .transform((v, orig) => (orig === '' ? null : v))
        .when('promoPackType', {
          is: PromoPackTypeEnum.STANDARD,
          then: (s) => s.min(1).nullable(),
        }),
      depositPercentage: number()
        .nullable()
        .transform((v, orig) => (orig === '' ? null : v))
        .when('promoPackType', {
          is: PromoPackTypeEnum.STANDARD,
          then: (s) => s.min(1).nullable(),
        }),
      customPromo: string()
        .nullable()
        .when('promoPackType', {
          is: PromoPackTypeEnum.CUSTOM,
          then: (s) =>
            s
              .required('Custom Promo is required')
              .max(48, 'Must not exceed 48 characters')
              .matches(/^[a-zA-Zа-яА-ЯёЁ\s0-9+%₽]+$/, 'Only letters, digits, spaces, and +, %, ₽ are allowed'),
        }),
    })
    .test(
      'at-least-one-standard-field',
      'At least one of Free Spins Count or Deposit Percentage is required',
      (value) => {
        if (value?.promoPackType !== PromoPackTypeEnum.STANDARD) return true;
        return (
          (value.freeSpinsCount != null && value.freeSpinsCount >= 1) ||
          (value.depositPercentage != null && value.depositPercentage >= 1)
        );
      }
    ),
  ymId: string().required(),
  link: string().required(),
  isActive: boolean().required(),
  logoVerticalId: string().nullable(),
  logoSquareId: string().nullable(),
  winNotificationText: string().required().max(64, 'Must not contain more than 64 characters (emoji - 2 characters)'),
});
